import { Component, OnInit } from '@angular/core';
import { SponsorService } from '../shared/services/sponsor.service';
import { Sponsor } from 'app/shared';
import { MatTableDataSource } from '@angular/material/table';
import { GuestRole } from 'app/shared/models/guest-role.model';


@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    standalone: false
})
export class AdminComponent implements OnInit {

  sponsors: Sponsor[] = new Array<Sponsor>();
  dataSource2: MatTableDataSource<Sponsor>;
  displayedColumns2: string[] = ['firstName', 'email', 'iNumber'];

  guests: GuestRole[];
  // dataSource : MatTableDataSource<GuestRole>;
  constructor(private sponsorService: SponsorService) { }

  ngOnInit() {
    this.sponsorService.getSponsors().subscribe(
      result => {
        this.sponsors = result;
        this.dataSource2 = new MatTableDataSource<Sponsor>(this.sponsors);
      }
    )
  }
}